"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Utility = {
  convertIntoBase64: function convertIntoBase64(data) {
    return btoa(data);
  },
  scriptHandler: function scriptHandler(scriptsArray, id) {
    //Add js links
    scriptsArray.forEach(function (item, index) {
      if (item) {
        // append script on container
        var script = document.createElement('script');
        script.src = item;
        script.nonce = '2646294A404E6352';
        script.key = index;
        script.async = true;
        document.getElementById(id).appendChild(script);
      }
    });
  },
  handleDropdown: function handleDropdown() {
    // fire event if click is outside of menu & close the menu list
    window.onclick = function (event) {
      if (event.code !== 'Enter' || event.keyCode !== 13) {
        if (!event.target.classList.contains('dropdown-toggle') && !event.target.classList.contains('menu_text') && !event.target.classList.contains('bars')) {
          var _document$querySelect;
          (0, _jquery.default)('.menu-list').slideUp('fast');
          if (((_document$querySelect = document.querySelector('#IdHeader .dropdown')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.length) > 0) document.querySelector('#IdHeader .dropdown').classList.remove('open');
        } else {
          document.querySelector('.dropdown-menu').style.display = 'block';
        }
      }
    };
  }
};
var _default = Utility;
exports.default = _default;